/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { FC, useEffect, useState } from "react";
import { motion } from "framer-motion";

import Label from "components/Label";
import { useTheme } from "theme/ThemeCreator";
import Media from "components/Media";
import { Step } from "../Flow/types";

import styles from "./styles.module.scss";

type Props = {
  forward: boolean;
  steps: Step[];
  currentStep: number;

  setCurrentStep(newStep: number): void;
};

const TabularProgress: FC<Props> = ({
  steps,
  currentStep,
  setCurrentStep,
  forward
}) => {
  const { colors } = useTheme();

  const backgroundColor = colors.primaryVariant1;
  const textColor = colors.primaryVariant2;
  const unselectedTextColor = colors.supplementalVariant1;

  const variants = {
    selected: {
      width: "100%",
      transition: { duration: 0.7, type: "linear", ease: "easeInOut" }
    },
    notSelected: {
      width: 0,
      transition: { duration: 0.7, type: "linear", ease: "easeInOut" }
    }
  };

  const [visited, setVisited] = useState<{ [key: string]: boolean }>({});

  useEffect(() => {
    setVisited({ ...visited, [currentStep]: true });
  }, [currentStep]);

  return (
    <div className={styles.container}>
      <div className={styles.items}>
        {steps.map(({ progressLabel }, index) => (
          <div
            key={progressLabel}
            className={styles.itemWrapper}
            onClick={
              index < currentStep || visited[index]
                ? () => setCurrentStep(index)
                : () => {}
            }
            style={{
              transition: "all 2s ease-in-out",
              width: `${100 / steps.length}%`,
              cursor:
                index < currentStep || visited[index] ? "pointer" : "default"
            }}
          >
            <Label
              style={{
                backgroundColor,
                color: index === currentStep ? textColor : unselectedTextColor
              }}
              className={styles.text}
              variant="small-centered-bold"
            >
              {(index + 1).toLocaleString("en-US", {
                minimumIntegerDigits: 2,
                useGrouping: false
              })}
            </Label>
            <Media at={["desktop"]}>
              <Label
                style={{
                  backgroundColor,
                  color: index === currentStep ? textColor : unselectedTextColor
                }}
                className={styles.text}
                variant="small-capitalized-centered-bold"
              >
                {progressLabel}
              </Label>
            </Media>
            <motion.div
              custom={{ forward, isCurrentStep: index === currentStep }}
              initial={false}
              style={{
                backgroundColor: textColor,
                ...(forward
                  ? index === currentStep
                    ? { left: 0, right: "unset" }
                    : { right: 0, left: "unset" }
                  : index === currentStep
                  ? { right: 0, left: "unset" }
                  : { left: 0, right: "unset" })
              }}
              variants={variants}
              animate={index === currentStep ? "selected" : "notSelected"}
              className={styles.progressBar}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default TabularProgress;
